import { addPanelType } from './panelsActions';
import { thunkUpdatePokerRoomForClosedMtt } from './pokerActions';
export const CLEAR_MTT_STATE = 'CLEAR_MTT_STATE';
export const SET_NUM_MTT_TABLES = 'SET_NUM_MTT_TABLES';
export const UPDATE_TOURNEY_STANDINGS_FROM_INBOUND = 'UPDATE_TOURNEY_STANDINGS_FROM_INBOUND';
export const CLEAR_TOURNEY_STANDINGS = 'CLEAR_TOURNEY_STANDINGS';
export function clearMttState() {
    return {
        type: CLEAR_MTT_STATE
    };
}
export function setNumMttTables(numMttTables) {
    return {
        type: SET_NUM_MTT_TABLES,
        payload: numMttTables
    };
}
export function closeMttTableFromInbound() {
    return function (dispatch) {
        dispatch(setNumMttTables(undefined));
        dispatch(thunkUpdatePokerRoomForClosedMtt());
    };
}
function updateTourneyStandingsFromInbound(inbound) {
    return {
        type: UPDATE_TOURNEY_STANDINGS_FROM_INBOUND,
        payload: inbound
    };
}
export function thunkUpdateTourneyStandingsFromInbound(inbound) {
    return function (dispatch) {
        // add the tourney standings panel, on demand and if it doesn't already exist, when this packet arrives:
        dispatch(addPanelType({
            type: 'tourneyStandings'
        }));
        dispatch(updateTourneyStandingsFromInbound(inbound));
    };
}
export function clearTourneyStandings() {
    return {
        type: CLEAR_TOURNEY_STANDINGS
    };
}
